export const pricingData = [
	{
		title: 'Basic',
		price: '₹300',
		numAcc: '50-100 accounts',
		features: ['Half time', '7am - 2pm / 2pm - 7pm', 'Books during library time.', 'All common facilities'],
	},
	{
		title: 'Standard',
		price: '₹600',
		numAcc: '50-500 accounts',
		features: ['Full time', '7am - 7pm', 'Books during library time.', 'All common facilities'],
	},
	{
		title: 'Premium',
		price: '₹700',
		numAcc: '50-1000 accounts',
		features: [
			'Additional 1 hour iff you want.',
			'You are allowed to take books for 2 days',
			'All common facilities',
		],
	},
];
